// extracted by mini-css-extract-plugin
export default {"root":"ProjectionLayout_root__oafft","container":"ProjectionLayout_container__XzH9v","main":"ProjectionLayout_main__uySNK"};